// pages/Products.js - FULL PAGE VERSION
import React from 'react';
import { Link } from 'react-router-dom';
import { Battery, Sun, Zap, Lock, Shield, Cable, ChevronRight } from 'lucide-react';

const Products = () => {
  const products = [
    {
      icon: Battery,
      name: 'UPS Systems',
      slug: 'ups',
      image: '/images/products/ups-systems.jpg',
      specs: '1kVA - 500kVA',
      description: 'Uninterruptible power supply for critical loads.',
      brands: ['Schneider Electric', 'Siemens', 'ABB'],
      link: '/products/ups'
    },
    {
      icon: Sun,
      name: 'Solar Panels',
      slug: 'solar',
      image: '/images/products/solar-panels.jpg',
      specs: '100W - 600W',
      description: 'High-efficiency solar panels.',
      brands: ['Jinko Solar', 'Canadian Solar', 'Trina Solar'],
      link: '/products/solar'
    },
    {
      icon: Zap,
      name: 'Generators',
      slug: 'generators',
      image: '/images/products/generators.jpg',
      specs: '5kVA - 2000kVA',
      description: 'Diesel, gas, and hybrid generators.',
      brands: ['Cummins', 'Caterpillar', 'Kohler'],
      link: '/products/generators'
    },
    {
      icon: Lock,
      name: 'Access Control',
      slug: 'access-control',
      image: '/images/products/access-control.jpg',
      specs: 'Biometric, RFID, Smart',
      description: 'Advanced access control systems.',
      brands: ['Hikvision', 'Dahua', 'ZKTeco'],
      link: '/products/access-control'
    },
    {
      icon: Shield,
      name: 'Security Systems',
      slug: 'security',
      image: '/images/products/security-systems.jpg',
      specs: 'CCTV, Alarms, Monitoring',
      description: 'Comprehensive security systems.',
      brands: ['Hikvision', 'Dahua', 'Axis'],
      link: '/products/security'
    },
    {
      icon: Cable,
      name: 'Structured Cabling',
      slug: 'cabling',
      image: '/images/products/structured-cabling.jpg',
      specs: 'Cat6, Fiber, Networks',
      description: 'Professional structured cabling.',
      brands: ['CommScope', 'Belden', 'Siemon'],
      link: '/products/cabling'
    }
  ];

  return (
    <div className="pt-20">
      <section className="relative py-16 bg-gradient-to-r from-[#006D77] to-[#008B8B] text-white">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold">Our Products</h1>
          <p className="text-lg text-white/80 mt-2 max-w-2xl mx-auto">
            Premium products from leading manufacturers for all your electrical needs
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {products.map((item, idx) => {
              const Icon = item.icon;
              return (
                <Link
                  key={idx}
                  to={item.link}
                  className="group bg-white rounded-xl overflow-hidden shadow hover:shadow-lg transition-all hover:-translate-y-1"
                >
                  <div className="h-48 overflow-hidden relative">
                    <img 
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      onError={(e) => {
                        e.target.src = `https://picsum.photos/seed/${item.slug}/800/600`;
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                    <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm p-2 rounded-lg">
                      <Icon className="w-4 h-4 text-[#006D77]" />
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-3">
                      <span className="text-white/70 text-xs block">{item.specs}</span>
                      <span className="text-white font-bold text-base block">{item.name}</span>
                    </div>
                  </div>
                  <div className="p-4">
                    <p className="text-gray-600 text-sm mb-2">{item.description}</p>
                    <div className="flex flex-wrap gap-1 mb-2">
                      {item.brands.slice(0, 3).map((brand, i) => (
                        <span key={i} className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
                          {brand}
                        </span>
                      ))}
                    </div>
                    <span className="inline-flex items-center text-[#006D77] font-medium text-sm hover:gap-1 transition-all">
                      View Details 
                      <ChevronRight size={14} className="ml-1" />
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
